import { styled } from "styled-components";

export const Wrapper = styled.div`
  max-height: 100vh;
  overflow: auto;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.colors.base};
  color: ${({ theme }) => theme.colors.default.default};
  overflow-x: hidden;
`;
